/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, Renderer2, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, OnDestroy {
  private widgetLoaded = false;
  private checkInterval: any;
  private scriptElement: any;

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    public authService: AuthService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    this.checkInterval = setInterval(() => {
      if (this.authService.isAuth && this.authService.userInSession && !this.widgetLoaded) {
        let usuarioLogueado = "usuario";
        if (this.authService.userInSession.username) {
          usuarioLogueado = this.authService.userInSession.username;
        }

        this.cargarWidgetChat(usuarioLogueado);
        this.widgetLoaded = true;
      } else if (!this.authService.isAuth && this.widgetLoaded) {
        // User logged out
        this.widgetLoaded = false;
        if (this.scriptElement) {
          this.renderer.removeChild(this.document.body, this.scriptElement);
          this.scriptElement = null;
        }

        // Ensure any injected iframe/DOM from widget is also cleaned up if possible
        const chatWidget = this.document.getElementById('solucionesgt360-chat-widget');
        if (chatWidget) {
          chatWidget.remove();
        }
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  cargarWidgetChat(usuario: string) {
    this.scriptElement = this.renderer.createElement('script');
    this.scriptElement.src = 'https://chatbots.solucionesgt360.com/js/widget.js';
    this.scriptElement.defer = true;

    // Configuramos los atributos del bot
    this.scriptElement.setAttribute('data-bot-id', '766ad44b-7b65-4ab8-b529-8c16eb724201');
    this.scriptElement.setAttribute('data-identity', usuario);

    this.renderer.appendChild(this.document.body, this.scriptElement);
  }
}
